import React from 'react';
import { Alert, Slide, Snackbar } from '@mui/material';
import { useAlert, ALERT_AUTO_HIDE_MS } from '../contexts/AlertContext';

// Slide the Snackbar up from the bottom-right.
const SlideUp = (props) => <Slide {...props} direction='up' />;

/**
 * GlobalAlert — the single, app-wide alert surface. Renders whatever the
 * AlertContext currently holds ({ message, severity }) as a dismissible MUI
 * Snackbar + Alert. Mounted once at the app root; every `useAlert().setAlert`
 * call site (and the API layer via the alert bridge) drives it.
 */
const GlobalAlert = () => {
  const { alert, clearAlert } = useAlert();

  const handleClose = (_event, reason) => {
    // Ignore click-away so a stray click doesn't dismiss an error the user
    // hasn't read; the timeout and the explicit close button still dismiss it.
    if (reason === 'clickaway') return;
    clearAlert();
  };

  return (
    <Snackbar
      open={Boolean(alert)}
      autoHideDuration={ALERT_AUTO_HIDE_MS}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={SlideUp}
      sx={{ zIndex: 100000 }}
    >
      {alert ? (
        <Alert
          onClose={handleClose}
          severity={alert.severity || 'success'}
          variant='filled'
          elevation={6}
          sx={{ width: '100%', alignItems: 'center' }}
        >
          {alert.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};

export default GlobalAlert;
